import React from 'react'

import { useTranslation } from '../../contexts/I18nContext'
import RecipeAccordionSection from '../RecipeAccordionSection'
import NutritionalFactsTable from '../NutritionalFactsTable'

import Styled from './RecipeNutritionalFacts.styled'

const RecipeNutritionalFacts = ({ id, className, nutritionalFacts, title }) => {
  const { t } = useTranslation()

  return (
    <RecipeAccordionSection
      className={className}
      id={id}
      title={t('RECIPE.NUTRITION_FACTS')}
      subtitle={t('RECIPE.NUTRITION_FACTS_EXPLANATION')}
      variant="primary"
    >
      <Styled>
        <NutritionalFactsTable
          nutritionalFacts={nutritionalFacts}
          title={title}
          withHumanSentence
        />
      </Styled>
    </RecipeAccordionSection>
  )
}

export default RecipeNutritionalFacts
